export default __webpack_public_path__ + "static/media/MetaMaskImg.dabbc866.png";